import React from 'react';
import { Box, Button, MenuItem, TextField, Typography } from '@mui/material';
import { formPrimaryButtonSx } from '../BaseForm/styles';

const SearchForm = ({ initialValues, tags }) => {
  return (
    <Box
      component="form"
      method="get"
      action="/search"
      sx={{
        width: '100%',
        maxWidth: '720px',
        margin: '16px auto 8px',
        padding: 2,
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
        ルーム検索
      </Typography>
      <TextField
        label="イベント名"
        name="eventName"
        defaultValue={initialValues.eventName}
        fullWidth
      />
      <TextField
        label="主催者名"
        name="ownerName"
        defaultValue={initialValues.ownerName}
        fullWidth
      />
      <TextField
        select
        label="タグ"
        name="tag"
        defaultValue={initialValues.tag}
        fullWidth
      >
        <MenuItem value="">指定なし</MenuItem>
        {(tags || []).map((tag) => (
          <MenuItem key={tag.id} value={tag.id}>
            {tag.name}
          </MenuItem>
        ))}
      </TextField>
      <Button type="submit" variant="contained" disableElevation sx={formPrimaryButtonSx}>
        検索
      </Button>
    </Box>
  );
};

export default SearchForm;
